<template>
  <div>
    <v-main>
      <v-row no-gutters class="ma-5">
        <v-col cols="2" class="pl-0">
          <h3 style="margin-bottom: 15px; color: black; font-weight: bolder">
            Dashboard
          </h3>
        </v-col>
        <v-col cols="10" style="text-align: end" class="px-0 pb-0">
          <v-row no-gutters>
            <v-col cols="4" class="mr-3">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    label="ค้นหาตามวันที่"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    hide-details
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      $refs.menu.save(date);
                      chackDate();
                    "
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="5" class="mr-3">
              <v-select
                v-model="WherehouseName"
                :items="dataWherehouse"
                label="Wherehouse Name"
                placeholder="Wherehouse Name"
                solo
                multiple
                dense
                hide-details
                flat
                clearable
                style="
                  border: 1px solid rgba(0, 0, 0, 0.38);
                  background: var(--neutral-white, #fff);
                "
              >
              </v-select>
            </v-col>
            <v-col
              cols="2"
              class="mr-3"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <!-- <v-btn text color="primary" @click="sent2()"> OK </v-btn> -->
              <v-btn class="mx-2" dark small color="primary" @click="sent2()">
                <v-icon dark> mdi-magnify </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                dark
                small
                color="success"
                @click="exportExcel()"
              >
                <v-icon dark> mdi-file-excel </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <!-- ลูกค้า -->
        <v-col cols="12" class="mt-3">
          <label>ลูกค้า</label>
        </v-col>
        <v-col cols="12">
          <v-row class="pt-3">
            <v-col cols="4" class="pa-3">
              <v-card class="d-flex pa-3 justify-space-between" rounded="lg">
                <div class="d-flex">
                  <v-card rounded="lg">
                    <v-card-text class="py-3 px-3 text-center">
                      <v-icon color="#EF543C">mdi-account-group </v-icon>
                    </v-card-text>
                  </v-card>
                  <div class="d-flex flex-column ps-3">
                    <span>ลูกค้าทั้งหมด</span>
                    <span
                      >{{ (userOld + userNews).toLocaleString("en") }} คน</span
                    >
                  </div>
                </div>
                <div class="ps-3"></div>
              </v-card>
            </v-col>
            <!-- <v-col cols="4" class="pa-3">
              <v-card class="d-flex pa-3  justify-space-between" rounded="lg" >
                <div class="d-flex ">
                <v-card rounded="lg">
                  <v-card-text class="py-3 px-3 text-center">
                    <v-icon color="#F5913A"
                      >mdi-account-clock
                    </v-icon>
                  </v-card-text>
                </v-card>
                <div class="d-flex flex-column ps-3">
                  <span>ลูกค้าเก่า</span>
                  <span>{{ userOld.toLocaleString("en") }} คน</span>
                </div>
              </div>
                <div class="ps-3" style="
                    align-content: center;
                ">
                  <b style="color: #F5913A;">{{ ((userOld * 100) / (userOld + userNews)).toFixed(2) }}%</b>
                </div>
              </v-card>
            </v-col> -->
            <v-col cols="4" class="pa-3">
              <v-card class="d-flex pa-3 justify-space-between" rounded="lg">
                <div class="d-flex flex-row w-100">
                  <div>
                    <v-card rounded="lg">
                      <v-card-text class="py-3 px-3 text-center">
                        <v-icon color="#EFC151" style="margin-left: -4px"
                          >mdi-account-clock
                        </v-icon>
                      </v-card-text>
                    </v-card>
                  </div>
                  <div
                    class="d-flex flex-row justify-content-between align-items-center w-100"
                  >
                    <div>
                      <div class="d-flex flex-column ps-3">
                        <span>ลูกค้าเก่า</span>
                        <span>{{ userOld.toLocaleString("en") }} คน</span>
                      </div>
                    </div>
                    <div>
                      <b style="color: #efc151"
                        >{{
                          isNaN((userOld * 100) / (userOld + userNews))
                            ? 0.0
                            : ((userOld * 100) / (userOld + userNews)).toFixed(
                                2,
                              )
                        }}%</b
                      >
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col cols="4" class="pa-3">
              <v-card class="d-flex pa-3 justify-space-between" rounded="lg">
                <div class="d-flex flex-row w-100">
                  <div>
                    <v-card rounded="lg">
                      <v-card-text class="py-3 px-3 text-center">
                        <v-icon color="#EFC151" style="margin-left: -4px"
                          >mdi-account-plus
                        </v-icon>
                      </v-card-text>
                    </v-card>
                  </div>
                  <div
                    class="d-flex flex-row justify-content-between align-items-center w-100"
                  >
                    <div>
                      <div class="d-flex flex-column ps-3">
                        <span>ลูกค้าใหม่</span>
                        <span>{{ userNews.toLocaleString("en") }} คน</span>
                      </div>
                    </div>
                    <div>
                      <b style="color: #efc151"
                        >{{
                          isNaN((userNews * 100) / (userOld + userNews))
                            ? 0.0
                            : ((userNews * 100) / (userOld + userNews)).toFixed(
                                2,
                              )
                        }}%</b
                      >
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-3">
          <v-row class="mt-3">
            <v-col col="12" sm="7">
              <v-card rounded="lg" class="pa-2">
                <apexcharts
                  type="bar"
                  ref="barChartVatical2"
                  :height="barChartVatical2.chartOptions.chart.height"
                  :options="barChartVatical2.chartOptions"
                  :series="barChartVatical2.series"
                ></apexcharts>
              </v-card>
            </v-col>
            <v-col col="12" sm="5">
              <v-card rounded="lg" class="h-100 pa-2">
                <v-card-title style="font-size: 14px">
                  <div class="row">
                    <div class="col-12">จำนวนลูกค้าซื้อซ้ำ</div>
                  </div>
                </v-card-title>
                <v-catd-item>
                  <v-data-table
                    :headers="dataHeadDupp"
                    :items="dataRowDupp"
                    :items-per-page="3"
                    dense
                  >
                    <template v-slot:[`item.persens`]="{ item }">
                      {{ ((item.value * 100) / countTotalTable).toFixed(2) }}
                    </template>
                  </v-data-table>
                </v-catd-item>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" class="mt-3">
          <label>รายได้</label>
        </v-col>
        <v-col cols="12" class="mt-3">
          <v-card class="d-flex pa-3 justify-space-between" rounded="lg">
            <div class="d-flex">
              <v-card class="py-3 px-3" rounded="lg">
                <v-card-text class="py-3 px-3 text-center">
                  <v-icon color="primary">mdi-cash </v-icon>
                </v-card-text>
              </v-card>
              <div
                class="d-flex flex-column ps-3"
                style="align-content: center"
              >
                <span>
                  <p class="h4">
                    ยอดรวมรายได้
                    {{
                      WherehouseName.length != 0
                        ? "(" + WherehouseName.length + " สาขา)"
                        : ""
                    }}
                  </p></span
                >
                <span>ตั้งแต่วันที่ {{ dateRangeText }} </span>
              </div>
            </div>
            <div
              class="ps-3 text-right"
              v-if="WherehouseName.length > 0"
              style="align-content: center"
            >
              <p class="h4">{{ sumNows.toLocaleString("en") }} บาท</p>
              <b
                class="h5"
                v-if="persenNow[0] !== 0"
                :style="`color:${persenNow[1] ? 'green' : 'red'}`"
                >{{ persenNow[0] }}%</b
              >
              <p class="h4" v-else>0 บาท</p>
              &nbsp;&nbsp;<label style="font-size: 13px"
                >ข้อมูลย้อนหลัง {{ countDays + 1 }} วัน
              </label>
            </div>
            <div class="ps-3 text-right" v-else style="align-content: center">
              <p class="h4">0 บาท</p>
              <b class="h5" :style="`color:green`">0%</b>&nbsp;&nbsp;<label
                style="font-size: 13px"
                >ข้อมูลย้อนหลัง 0 วัน
              </label>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" class="mt-3">
          <div
            class="container-overview"
            style="border: 1px solid #dadada; align-content: center"
          >
            <apexcharts
              type="line"
              height="350"
              ref="lineChart"
              :options="lineChart.chartOptions"
              :series="lineChart.series"
            ></apexcharts>
          </div>
        </v-col>
        <v-col cols="12" class="mt-3">
          <div
            class="container-overview"
            style="border: 1px solid #dadada; align-content: center"
          >
            <apexcharts
              type="bar"
              ref="barChartVatical1"
              :height="barChartVatical1.chartOptions.chart.height"
              :options="barChartVatical1.chartOptions"
              :series="barChartVatical1.series"
            ></apexcharts>
          </div>
        </v-col>
        <v-col cols="12" class="mt-3">
          <div
            class="container-overview"
            style="border: 1px solid #dadada; align-content: center"
          >
            <apexcharts
              type="bar"
              ref="barChartHorizon"
              :height="barChartHorizon.chartOptions.chart.height"
              :width="barChartHorizon.chartOptions.chart.width"
              :options="barChartHorizon.chartOptions"
              :series="barChartHorizon.series"
            ></apexcharts>
          </div>
        </v-col>
        <v-col cols="12" class="mt-3">
          <label>สินค้า</label>
        </v-col>

        <v-col cols="12" class="mt-3">
          <v-row class="mt-3">
            <v-col col="12" sm="6">
              <v-card rounded="lg" class="d-flex pa-6" style="height: 100%">
                <div class="d-flex flex-column w-100">
                  <div>
                    5 อันดับแบรนด์ที่มียอดขายโทรศัพท์สูงสุด (คิดจากรายได้)
                  </div>
                  <div class="d-flex justify-content-center w-100">
                    <apexcharts
                      ref="donutChart2"
                      width="150%"
                      type="donut"
                      :options="donutChart2.chartOptions"
                      :series="donutChart2.series"
                    ></apexcharts>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col col="12" sm="6">
              <v-card rounded="lg" class="d-flex pa-6" style="height: 100%">
                <div class="d-flex flex-column w-100">
                  <div>
                    5 อันดับแบรนด์ที่มียอดจำหน่ายโทรศัพท์สูงสุด
                    (นับตามจำนวนเครื่อง)
                  </div>
                  <div class="d-flex justify-content-center w-100">
                    <apexcharts
                      ref="donutChart1"
                      width="150%"
                      type="donut"
                      :options="donutChart1.chartOptions"
                      :series="donutChart1.series"
                    ></apexcharts>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" class="mt-3">
          <div
            class="container-overview"
            style="border: 1px solid #dadada; align-content: center"
          >
            <apexcharts
              type="bar"
              ref="barChartHorizon2"
              :height="barChartHorizon2.chartOptions.chart.height"
              :width="barChartHorizon2.chartOptions.chart.width"
              :options="barChartHorizon2.chartOptions"
              :series="barChartHorizon2.series"
            ></apexcharts>
          </div>
        </v-col>
      </v-row>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import readXlsxFile from 'read-excel-file'
import XLSX from 'xlsx' // import xlsx
export default {
  components: {
    downloadExcel: JsonExcel,
    readXlsxFile,
    XLSX,
    name: '',
    apexcharts: VueApexCharts
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
    },
    dateRangeText () {
      return (
        this.thaiFormattedDate(this.date[0]) +
          '-' +
          this.thaiFormattedDate(this.date[1]) || ''
      )
    },
    isAllSelected () {
      return this.WherehouseName.length === this.dataWherehouse.length
    }
  },
  watch: {},
  data () {
    return {
      dfColor: {},
      sortItemGroupObj: {},
      sortItemGroupArr: [],
      sumByDate1: {},
      sumByDate2: {},
      originalDashboard: null,
      dataBranchLinechart: {},
      dataBranchKeyDateLinechart: {},
      dataBranchVatical1: {},
      dataBranchStack: {},
      dataBranchHorizontal: {},
      dataBranchVatical2: {},
      dataBranchDonut: {},
      dataBranchDonutDup: {},
      dataBranchDonutDupkey: {},
      countStatusMember: {},
      loading: false,
      date: [],
      menu: false,
      WherehouseName: [],
      dataWherehouse: [],
      MonthSelected: [],
      MonthDefual: [
        { text: 'All', value: '00' },
        { text: 'JAN', value: '01' },
        { text: 'FEB', value: '02' },
        { text: 'MAR', value: '03' },
        { text: 'APR', value: '04' },
        { text: 'MAY', value: '05' },
        { text: 'JUN', value: '06' },
        { text: 'JUL', value: '07' },
        { text: 'AUG', value: '08' },
        { text: 'SEP', value: '09' },
        { text: 'OCT', value: '10' },
        { text: 'NOV', value: '11' },
        { text: 'DEC', value: '12' }
      ],
      dataMonth: [],
      barChartHorizon: {
        series: [],
        chartOptions: {
          colors: [],
          title: {
            text: 'ยอดขายแต่ละกลุ่ม',
            align: 'left'
          },
          chart: {
            type: 'bar',
            height: '200%',
            width: '100%',
            stacked: true
          },
          grid: {
            show: false // เอาเส้นตารางออก
          },
          dataLabels: {
            formatter: function (val) {
              return (val || 0).toLocaleString('en')
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 3,
              horizontal: true,
              dataLabels: {
                total: {
                  formatter: function (val) {
                    return (val || 0).toLocaleString('en')
                  },
                  enabled: true
                  // offsetX: 0,
                  // style: {
                  //   fontSize: '13px',
                  //   fontWeight: 900
                  // }
                }
              }
            }
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: [],
            labels: {
              formatter: function (val) {
                return (val || 0).toLocaleString('en')
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val.toLocaleString('en') + ' บาท' || 0 + ' บาท'
              }
            }
          }
        }
      },
      barChartVatical1: {
        series: [
          {
            name: 'ยอดขาย',
            data: []
          }
        ],
        chartOptions: {
          colors: [],
          chart: {
            height: '200%',
            // toolbar: false,
            width: '100%',
            type: 'bar'
            // zoom: {
            //   enabled: false
            // }
          },
          plotOptions: {
            bar: {
              distributed: true,
              borderRadius: 5,
              columnWidth: '10%',
              dataLabels: {
                position: 'top' // top, center, bottom
              }
            }
          },

          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return (val || 0).toLocaleString('en')
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ['#304758']
            }
          },
          yaxis: {
            reversed: false,
            labels: {
              formatter: (value) => {
                return value.toLocaleString('en') + ' บาท' || 0 + ' บาท'
              }
            }
          },
          xaxis: {
            categories: []
          },
          title: {
            text: 'รายได้แบ่งตามสาขา (บาท)',
            align: 'left'
          }
        }
      },
      barChartVatical2: {
        series: [
          {
            name: 'Inflation',
            data: []
          }
        ],
        chartOptions: {
          title: {
            text: 'จำนวนลูกค้าแบ่งตามสาขา',
            align: 'left'
          },
          chart: {
            height: '150%',
            stacked: true,
            type: 'bar',
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 5,
              columnWidth: '20%',
              dataLabels: {
                position: 'top' // top, center, bottom
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val || ''
            },
            offsetY: -20,
            style: {
              fontSize: '12px',
              colors: ['#304758']
            }
          },
          xaxis: {
            type: 'category',
            categories: [],
            position: 'top',
            crosshairs: {
              fill: {
                type: 'gradient',
                gradient: {
                  colorFrom: '#D8E3F0',
                  colorTo: '#BED1E6',
                  stops: [0, 100],
                  opacityFrom: 0.4,
                  opacityTo: 0.5
                }
              }
            },
            tooltip: {
              enabled: true
            }
          },
          yaxis: {
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            },
            labels: {
              show: false,
              formatter: function (val) {
                return val || ''
              }
            }
          },
          legend: {
            markers: {
              size: 7,
              shape: 'circle'
            },
            position: 'bottom',
            show: false,
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            labels: {
              colors: '#ssssss',
              useSeriesColors: false
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }
          ]
        }
      },
      lineChart: {
        series: [],
        chartOptions: {
          chart: {
            height: '100%',
            type: 'line',
            toolbar: false,
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight',
            width: 2
          },
          title: {
            text: 'รายได้ต่อวันรวมทุกสาขา (บาท)',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#16B1FF', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.1
            }
          },
          xaxis: {
            type: 'datetime',
            formatter: function (value, timestamp) {
              // สร้างออบเจกต์ Date ใหม่จาก timestamp
              var date = new Date(timestamp)

              // ใช้ Intl.DateTimeFormat เพื่อจัดรูปแบบวันที่
              return (
                date.toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                }) || ''
              )
            }
          },
          yaxis: {
            labels: {
              formatter: (value) => {
                return value.toLocaleString('en') + ' บาท' || 0 + ' บาท'
              }
            }
          }
        }
      },
      sumNows: 0,
      sumBefores: 0,
      persenNow: [0, true],
      countDays: 0,
      userOld: 0,
      userNews: 0,
      userAlls: 0,
      dataHeadDupp: [],
      dataRowDupp: [],
      countTotalTable: 0,
      donutChart1: {
        series: [], // Example data
        chartOptions: {
          colors: [],
          chart: {
            type: 'donut',
            width: '150%'
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: '150%' // Custom width for smaller screens
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ],
          labels: [],
          dataLabels: {
            enabled: true
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  value: {
                    show: true,
                    formatter: (value) => {
                      return (
                        (Number(value) || 0).toLocaleString('en') +
                          ' เครื่อง' || 0
                      )
                    }
                  }
                }
              }
            }
          },
          legend: {
            markers: {
              size: 7,
              shape: 'circle'
            },
            position: 'bottom'
          }
        }
      },
      donutChart2: {
        series: [], // Example data
        chartOptions: {
          colors: [],
          chart: {
            type: 'donut',
            width: '150%'
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: '150%' // Custom width for smaller screens
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ],
          labels: [],
          dataLabels: {
            enabled: true
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  value: {
                    show: true,
                    formatter: (value) => {
                      return (
                        (Number(value) || 0).toLocaleString('en') + ' บาท' ||
                        0 + ' บาท'
                      )
                    }
                  }
                }
              }
            }
          },
          legend: {
            markers: {
              size: 7,
              shape: 'circle'
            },
            position: 'bottom'
          }
        }
      },
      dataTelephone: null,
      dataAccessory: null,
      dataFillAccessory: null,
      dataFillTelephone: [],
      arrColor: [],
      topDefault: 5,

      barChartHorizon2: {
        series: [],
        chartOptions: {
          colors: [],
          title: {
            text: '5 อันดับแรกของแบรนด์ที่มียอดขายสินค้า Accessory สูงสุด',
            align: 'left'
          },
          chart: {
            type: 'bar',
            height: '200%',
            width: '100%',
            stacked: true
          },
          grid: {
            show: false // เอาเส้นตารางออก
          },
          dataLabels: {
            formatter: function (val) {
              return (val || 0).toLocaleString('en')
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 3,
              horizontal: true,
              dataLabels: {
                total: {
                  formatter: function (val) {
                    return (val || 0).toLocaleString('en')
                  },
                  enabled: true,
                  offsetX: 0,
                  style: {
                    fontSize: '13px',
                    fontWeight: 900
                  }
                }
              }
            }
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: [],
            labels: {
              formatter: function (val) {
                return (val || 0).toLocaleString('en')
              }
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val.toLocaleString('en') + ' บาท' || 0 + ' บาท'
              }
            }
          }
        }
      }
    }
  },
  created () {},
  destroyed () {},
  async mounted () {
    await this.getColors()
    await this.chackDate()
  },
  methods: {
    async exportExcel () {
      // const obj = { DOCDATE: this.date, BRANCHCODE: this.WherehouseName, shopId: this.$session.getAll().data.shopId }
      console.log('dataExcels>>>>>>', this.date)
      console.log('dataExcels>>>>>>', this.WherehouseName)
      console.log('dataExcels>>>>>>', this.$session.getAll().data.shopId)
      try {
        const dataExcels = await axios.post(
          this.DNS_IP + '/hitorysell/get-dashboard-member-dup-excel',
          {
            DOCDATE: this.date,
            BRANCHCODE: this.WherehouseName,
            shopId: this.$session.getAll().data.shopId
          }
        )
        if (Object.entries(dataExcels.data).length) {
          console.log('dataExcels>>>', dataExcels)
          let pushDataFinal = []
          for await (const val of Object.entries(dataExcels.data)) {
            console.log('>>>', val)
            let obj = {}
            try {
              obj = {
                'ชื่อ-สกุล': val[1].dataMember.nameCustomer || '',
                'ชื่อ Line': val[1].dataMember.name || '',
                คะแนนคงเหลือ: val[1].dataMember.currentPoint || '',
                เพศ: val[1].dataMember.gender || '',
                ระดับ: val[1].dataMember.LevelName || '',
                เบอร์โทร: val[0],
                จำนวนชื้อซ้ำ: val[1].total,
                วันเดือนปีเกิด: val[1].dataMember.birthDay || '',
                อายุ: val[1].dataMember.age || '',
                liffUserId: val[1].dataMember.liffUserI || ''
              }
            } catch (err) {
              obj = {
                'ชื่อ-สกุล': '',
                'ชื่อ Line': '',
                คะแนนคงเหลือ: '',
                เพศ: '',
                ระดับ: '',
                เบอร์โทร: val[0],
                จำนวนชื้อซ้ำ: val[1].total,
                วันเดือนปีเกิด: '',
                อายุ: '',
                liffUserId: ''
              }
            }
            pushDataFinal.push(obj)
          }

          const dataWS = XLSX.utils.json_to_sheet(pushDataFinal)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          const dNow = new Date()
          XLSX.writeFile(
            wb,
            'Report_dupp_member_' + moment(dNow).format('YYYYMMDD') + '.xlsx'
          )
        }
        console.log('dataExcels >>>', dataExcels)
      } catch (errs) {
        console.log('errors', errs)
      }
    },
    async getColors () {
      try {
        const colorData = await axios.get(
          // 'http://localhost:5001/bvpcolor/get'
          this.DNS_IP + '/bvpcolor/get'
        )
        if (colorData.data.length) {
          for await (const i of colorData.data) {
            this.dfColor[i.BranchCode] = []
            this.dfColor[i.BranchCode].push(i.ColorActive)
            this.dfColor[i.BranchCode].push(i.ColorHover)
            this.arrColor.push(i.ColorActive)
          }
        }
        // console.log('this.dfColor >>', this.dfColor)
      } catch (err) {
        console.log('err color', err)
      }
    },
    covDate (e) {
      const Y = e.getFullYear()
      const M = e.getMonth() + 1
      const D = e.getDate()
      return [
        Y + '-' + String(M).padStart(2, '0') + '-' + String(D).padStart(2, '0'),
        Y + String(M).padStart(2, '0') + String(D).padStart(2, '0')
      ]
    },

    selectAll () {
      if (this.WherehouseName.length === this.dataWherehouse.length) {
        // Deselect all if already all are selected
        this.WherehouseName = []
      } else {
        // Select all if not all are selected
        this.WherehouseName = [...this.dataWherehouse]
      }
    },
    getDate30 () {
      const now = new Date()
      let dStY = now.getFullYear()
      let dStM = now.getMonth() + 1
      let dStD = String(now.getDate()).padStart(2, '0')
      const DateStop = dStY + '-' + String(dStM).padStart(2, '0') + '-' + dStD
      if (dStM === 1) {
        dStY = dStY - 1
        dStM = 12
      } else {
        dStM = dStM - 1
      }
      const DateStart = dStY + '-' + String(dStM).padStart(2, '0') + '-' + dStD
      return [DateStart, DateStop]
    },
    daysBetween (dx) {
      try {
        const d1 = new Date(dx[0])
        const d2 = new Date(dx[1])
        // console.log('dx[0] : ', dx[0], 'dx[1] : ', dx[1])
        if (dx[0] !== dx[1]) {
          const diffTime = Math.abs(d2 - d1)
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
          const today = moment(dx[0])
          const newDate = today.subtract(diffDays, 'days')
          // console.log(newDate.format('YYYY-MM-DD'))
          this.countDays = diffDays
          let specificDate = new Date(newDate.format('YYYY-MM-DD'))
          specificDate.setDate(specificDate.getDate() - 1)
          // console.log(
          //   'return date: ',
          //   specificDate.toISOString().split('T')[0]
          // )
          return specificDate.toISOString().split('T')[0]
        } else {
          let specificDate = new Date(dx[0])
          specificDate.setDate(specificDate.getDate() - 1)
          this.countDays = 0
          // console.log(
          //   'return date: ',
          //   specificDate.toISOString().split('T')[0]
          // )
          return specificDate.toISOString().split('T')[0]
        }
      } catch (err) {
        return false
      }
    },
    // clearData () {
    //   this.lineChart.series = []
    //   this.barChartHorizon.series = []
    //   this.barChartHorizon.chartOptions.xaxis.categories = []
    //   this.barChartVatical1.series[0].data = []
    //   this.barChartVatical1.chartOptions.xaxis.categories = []
    //   this.barChartVatical2.series[0].data = []
    //   this.barChartVatical2.chartOptions.xaxis.categories = []
    // },
    sortItem (a, b) {
      return a[1] - b[1]
    },
    async sent2 () {
      try {
        this.$swal({
          title: 'Loading...',
          timerProgressBar: true,
          allowOutsideClick: false
        })
        console.log('this.dataWherehouse >>>>>>>', this.dataWherehouse)
        for await (const i of this.dataWherehouse) {
          this.dataBranchLinechart[i.value] = []
          this.dataBranchKeyDateLinechart[i.value] = {}
          for (
            let day = new Date(this.date[0]);
            day <= new Date(this.date[1]);
            day.setDate(day.getDate() + 1)
          ) {
            const keyDate = moment(day).format('YYYY-MM-DD')
            this.dataBranchKeyDateLinechart[i.value][keyDate] = 0
          }
          // this.dataWherehouse.push({
          //   text: i.value,
          //   value: i.value
          // })
          this.dataBranchDonut[i.value] = [0, 0]
          this.dataBranchVatical1[i.value] = 0
          this.dataBranchVatical2[i.value] = []
          this.dataBranchStack[i.value] = {}
          this.dataBranchHorizontal[i.value] = null
          this.dataBranchDonutDup[i.value] = {}
        }
        // if (this.WherehouseName.length) {
        //   await this.clearDash()
        // }

        if (this.WherehouseName.length) {
          for await (const i of this.WherehouseName) {
            // console.log('>>>>>>>>>>>>> i ', i)
            this.dataBranchDonut[i] = [0, 0]
            this.dataBranchVatical1[i] = 0
            this.dataBranchVatical2[i] = []
            this.dataBranchStack[i] = {}
            this.dataBranchHorizontal[i] = null
            this.dataBranchDonutDup[i] = {}
          }

          this.$swal.showLoading()
          const dayDif = this.daysBetween(this.date)
          if (dayDif) {
            // console.log('this.date[0] >> ', this.date[0])
            let specificDate = new Date(this.date[0])
            specificDate.setDate(specificDate.getDate() - 1)
            // console.log(
            //   'dayDif : ',
            //   dayDif,
            //   'specificDate >> ',
            //   specificDate.toISOString().split('T')[0]
            // )
            // console.log('---', specificDate.toISOString().split('T')[0])
            // console.log('dayDif', dayDif)

            const dataDashboardAfter = await axios.post(
              this.DNS_IP + '/hitorysell/get-dashboard-row-after',
              {
                DOCDATE: [dayDif, specificDate.toISOString().split('T')[0]],
                BRANCHCODE: this.WherehouseName
              }
            )
            // console.log('dataDashboardAfter', dataDashboardAfter.data)
            if (dataDashboardAfter.data.length) {
              this.sumByDate1 = {}
              for await (let i of dataDashboardAfter.data) {
                const nDate = new Date(i.DOCDATE)
                if (this.sumByDate1[i.BRANCHCODE] === undefined) {
                  this.sumByDate1[i.BRANCHCODE] = {}
                }
                if (
                  this.sumByDate1[i.BRANCHCODE][nDate.getTime()] === undefined
                ) {
                  this.sumByDate1[i.BRANCHCODE][nDate.getTime()] = 0
                  this.sumByDate1[i.BRANCHCODE][nDate.getTime()] +=
                    i.F_NETEXPRICE
                } else {
                  this.sumByDate1[i.BRANCHCODE][nDate.getTime()] +=
                    i.F_NETEXPRICE
                }
              }
            }
          }
          const dataDashboard = await axios.post(
            this.DNS_IP + '/hitorysell/get-dashboard-row',
            { DOCDATE: this.date, BRANCHCODE: this.WherehouseName }
          )
          this.sumByDate2 = {}
          if (dataDashboard.data.length) {
            for await (const i of dataDashboard.data) {
              if (this.sumByDate2[i.BRANCHCODE] === undefined) {
                this.sumByDate2[i.BRANCHCODE] = {}
              }
              if (this.sumByDate2[i.BRANCHCODE][i.DOCDATE] === undefined) {
                this.sumByDate2[i.BRANCHCODE][i.DOCDATE] = 0
                this.sumByDate2[i.BRANCHCODE][i.DOCDATE] += i.F_NETEXPRICE
              } else {
                this.sumByDate2[i.BRANCHCODE][i.DOCDATE] += i.F_NETEXPRICE
              }
              if (this.dataBranchStack[i.BRANCHCODE] === undefined) {
                this.dataBranchStack[i.BRANCHCODE] = {}
              }
              // console.log('this.dataBranchStack[i.BRANCHCODE]', this.dataBranchStack[i.BRANCHCODE])
              if (
                this.dataBranchStack[i.BRANCHCODE][i.ItemGROUP] === undefined
              ) {
                this.dataBranchStack[i.BRANCHCODE][i.ItemGROUP] = parseInt(
                  i.F_NETEXPRICE
                )
              } else {
                this.dataBranchStack[i.BRANCHCODE][i.ItemGROUP] += parseInt(
                  i.F_NETEXPRICE
                )
              }

              if (!this.dataBranchHorizontal[i.BRANCHCODE]) {
                this.dataBranchHorizontal[i.BRANCHCODE] = {}
              }
              if (!this.dataBranchHorizontal[i.BRANCHCODE][i.ItemGROUP]) {
                this.dataBranchHorizontal[i.BRANCHCODE][i.ItemGROUP] = 0
              }
              this.dataBranchHorizontal[i.BRANCHCODE][i.ItemGROUP] += parseInt(
                i.F_NETEXPRICE
              )
              if (!this.sortItemGroupObj[i.ItemGROUP]) {
                this.sortItemGroupObj[i.ItemGROUP] = 0
              }
              this.sortItemGroupObj[i.ItemGROUP] += parseInt(i.F_NETEXPRICE)

              this.dataBranchVatical1[i.BRANCHCODE] += parseInt(i.F_NETEXPRICE)
              // eslint-disable-next-line standard/computed-property-even-spacing
              this.dataBranchKeyDateLinechart[i.BRANCHCODE][
                moment(i.DOCDATE).format('YYYY-MM-DD')
              ] += parseInt(i.F_NETEXPRICE)
            }
            for await (const R of Object.entries(
              this.dataBranchKeyDateLinechart
            )) {
              for await (const S of Object.entries(R[1])) {
                this.dataBranchLinechart[R[0]].push({
                  x: new Date(S[0]).getTime(),
                  y: parseInt(S[1])
                })
              }
            }

            // console.log('this.sumByDate1 after', this.sumByDate1)
            // console.log('this.sumByDate2 nows', this.sumByDate2)

            for await (const d of this.WherehouseName) {
              for await (const vSort of Object.entries(this.sortItemGroupObj)) {
                if (!this.dataBranchHorizontal[d][vSort[0]]) {
                  this.dataBranchHorizontal[d][vSort[0]] = 0
                }
              }
            }
          }
          const dataDashboardMember = await axios.post(
            this.DNS_IP + '/hitorysell/get-dashboard-member',
            { DOCDATE: this.date, BRANCHCODE: this.WherehouseName }
          )
          if (dataDashboardMember.data.length) {
            this.countStatusMember = {}
            for await (const i of dataDashboardMember.data) {
              // console.log('><><>< I <><>><>', i)
              if (!this.countStatusMember[i.BRANCHCODE]) {
                this.countStatusMember[i.BRANCHCODE] = [0, 0]
              }
              this.countStatusMember[i.BRANCHCODE][i.STATUS_MEMBER]++
              this.dataBranchDonut[i.BRANCHCODE][i.STATUS_MEMBER]++
            }
          }
          console.log('this.countStatusMember >>>>>', this.countStatusMember)
          const dataDashboardDup = await axios.post(
            this.DNS_IP + '/hitorysell/get-dashboard-member-dup-v2',
            { DOCDATE: this.date, BRANCHCODE: this.WherehouseName }
          )
          this.dataBranchDonutDupkey = {}
          console.log('dataDashboardDup >>>>', dataDashboardDup)
          if (dataDashboardDup.data.length) {
            this.dataBranchDonutDupkey = dataDashboardDup.data[0]
            // console.log('dataDashboardDup.data >>>>>', dataDashboardDup.data[0])
            // console.log('dataBranchDonutDupkey.data >>', this.dataBranchDonutDupkey)
          }
          // console.log('this.dataBranchDonutDupkeythis.dataBranchDonutDupkey', this.dataBranchDonutDupkey)
          // console.log('this.dataBranchDonutDup >>', this.dataBranchDonutDup)
          const dataDashboardTel = await axios.post(
            this.DNS_IP + '/hitorysell/get-dashboard-telephone',
            // 'http://localhost:5001/hitorysell/get-dashboard-telephone',
            { DOCDATE: this.date, BRANCHCODE: this.WherehouseName }
          )
          this.dataTelephone = null
          if (dataDashboardTel.data.length) {
            this.dataTelephone = dataDashboardTel.data
          }

          const dataDashboardAcc = await axios.post(
            this.DNS_IP + '/hitorysell/get-dashboard-accessory',
            { DOCDATE: this.date, BRANCHCODE: this.WherehouseName }
          )
          this.dataAccessory = null
          if (dataDashboardAcc.data.length) {
            this.dataAccessory = dataDashboardAcc.data
          }
          // console.log('this.WherehouseName.length', this.WherehouseName.length)

          await this.changeWherehouse()
        } else {
          await this.clearDash()
        }
        this.$swal.close()
      } catch (err) {
        console.log('err', err)
      }
    },
    async changeWherehouse () {
      try {
        this.sumNows = 0
        this.sumBefores = 0
        // console.log('----------------------')
        // console.log('this.dataAccessory >>>>>', this.dataAccessory)
        this.dataFillAccessory = null
        if (this.dataAccessory !== null) {
          this.dataFillAccessory = this.dataAccessory.filter((d) =>
            this.WherehouseName.includes(d.BRANCHCODE)
          )
        }

        // console.log('this.dataFillAccessory >>>>>', this.dataFillAccessory)
        this.userOld = 0
        this.userNews = 0

        let ObjAccBrand = {}
        let ObjGroupAccBrand = {}
        let ObjAccCat = {}
        let arrTopCat = []
        let arrTopBrand = []
        if (this.dataFillAccessory !== null) {
          for await (const acc of this.dataFillAccessory) {
            if (ObjAccCat[acc.CategoryType] === undefined) {
              ObjAccCat[acc.CategoryType] = acc.sumPrice
            } else {
              ObjAccCat[acc.CategoryType] += acc.sumPrice
            }
            if (ObjAccBrand[acc.BRANDCODE] === undefined) {
              ObjAccBrand[acc.BRANDCODE] = acc.sumPrice
            } else {
              ObjAccBrand[acc.BRANDCODE] += acc.sumPrice
            }
            if (ObjGroupAccBrand[acc.BRANDCODE] === undefined) {
              ObjGroupAccBrand[acc.BRANDCODE] = {}
              if (
                ObjGroupAccBrand[acc.BRANDCODE][acc.CategoryType] === undefined
              ) {
                ObjGroupAccBrand[acc.BRANDCODE][acc.CategoryType] =
                  acc.sumPrice
              } else {
                ObjGroupAccBrand[acc.BRANDCODE][acc.CategoryType] +=
                  acc.sumPrice
              }
            } else {
              if (
                ObjGroupAccBrand[acc.BRANDCODE][acc.CategoryType] === undefined
              ) {
                ObjGroupAccBrand[acc.BRANDCODE][acc.CategoryType] =
                  acc.sumPrice
              } else {
                ObjGroupAccBrand[acc.BRANDCODE][acc.CategoryType] +=
                  acc.sumPrice
              }
            }
          }
        }
        let arrDataAcc = []
        // console.log('111')
        const entriesAccCat = Object.entries(ObjAccCat)
        entriesAccCat.sort((a, b) => b[1] - a[1])
        let coTopCat = 1
        for await (const catAcc of Object.entries(
          Object.fromEntries(entriesAccCat)
        )) {
          if (coTopCat <= this.topDefault) {
            arrTopCat.push(catAcc[0])
            arrDataAcc.push({ data: [], name: catAcc[0] })
            this.barChartHorizon2.chartOptions.colors.push(
              this.arrColor[coTopCat - 1]
            )
          }
          coTopCat++
        }
        // console.log('222')

        let coTopBrand = 1
        const entriesAcc = Object.entries(ObjAccBrand)
        entriesAcc.sort((a, b) => b[1] - a[1])
        const sortAccBrand = Object.fromEntries(entriesAcc)
        for await (const iBrand of Object.entries(sortAccBrand)) {
          if (coTopBrand <= this.topDefault) {
            arrTopBrand.push(iBrand[0])
          }
          coTopBrand++
        }
        // console.log('333')
        let dataChartAcc = []

        for await (const dAcc of arrTopCat) {
          dataChartAcc.push({
            data: [],
            name: dAcc
          })
        }
        // console.log('444')
        this.barChartHorizon2.chartOptions.xaxis.categories = []
        this.barChartHorizon2.series = []
        for await (const iBan of arrTopBrand) {
          for await (const iCat of arrTopCat) {
            if (iBan !== 'Any') {
              if (iCat !== 'Any') {
                dataChartAcc[arrTopCat.indexOf(iCat)]['data'].push(
                  ObjGroupAccBrand[iBan][iCat] || 0
                )
              }
            }
          }
          this.barChartHorizon2.chartOptions.xaxis.categories.push(iBan)
        }
        this.barChartHorizon2.series = dataChartAcc

        this.lineChart.series = []
        this.barChartVatical1.series[0].data = []
        this.barChartVatical1.chartOptions.xaxis.categories = []
        this.barChartVatical1.chartOptions.colors = []
        this.barChartVatical2.series = []
        this.barChartVatical2.chartOptions.xaxis.categories = []
        this.barChartHorizon.series = []
        this.barChartHorizon.chartOptions.colors = []
        this.barChartHorizon.chartOptions.xaxis.categories = []
        let chkWhereHouseData = 0

        let sortTeleCo = {}
        let sortTeleTo = {}
        if (this.dataTelephone !== null) {
          this.dataFillTelephone = this.dataTelephone.filter((d) =>
            this.WherehouseName.includes(d.BRANCHCODE)
          )
        }
        if (this.dataFillTelephone.length !== 0) {
          for await (const t of this.dataFillTelephone) {
            if (sortTeleCo[t.BRANDCODE] !== undefined) {
              sortTeleCo[t.BRANDCODE] += t.sumPrice
              sortTeleTo[t.BRANDCODE] += t.countUnit
            } else {
              sortTeleCo[t.BRANDCODE] = t.sumPrice
              sortTeleTo[t.BRANDCODE] = t.countUnit
            }
          }

          const entriesCo = Object.entries(sortTeleCo)
          entriesCo.sort((a, b) => b[1] - a[1])
          let topCo = 1
          let arrCo = []
          this.donutChart2.chartOptions.labels = []
          let totalCoAny = 0
          for await (const iCo of Object.entries(
            Object.fromEntries(entriesCo)
          )) {
            if (topCo <= this.topDefault) {
              let objNews = {}
              objNews[iCo[0]] = iCo[1]
              this.donutChart2.chartOptions.labels.push(iCo[0])
              this.donutChart2.chartOptions.colors.push(
                this.arrColor[topCo - 1]
              )
              arrCo.push(objNews)
            } else {
              totalCoAny += iCo[1]
            }
            topCo++
          }
          if (totalCoAny !== 0) {
            arrCo.push({ Any: totalCoAny })
            this.donutChart2.chartOptions.colors.push(this.arrColor[topCo])
            this.donutChart2.chartOptions.labels.push('Any')
          }
          this.donutChart2.series = []
          for await (const tt of arrCo) {
            this.donutChart2.series.push(Object.entries(tt)[0][1])
          }

          const entriesTo = Object.entries(sortTeleTo)
          entriesTo.sort((a, b) => b[1] - a[1])
          let topTo = 1
          let arrTo = []
          let totalToAny = 0
          this.donutChart1.chartOptions.labels = []

          for await (const iTo of Object.entries(
            Object.fromEntries(entriesTo)
          )) {
            if (topTo <= this.topDefault) {
              let objNews = {}
              objNews[iTo[0]] = iTo[1]
              this.donutChart1.chartOptions.labels.push(iTo[0])
              this.donutChart1.chartOptions.colors.push(
                this.arrColor[topTo - 1]
              )
              arrTo.push(objNews)
            } else {
              totalToAny += iTo[1]
            }
            topTo++
          }
          if (totalToAny !== 0) {
            arrTo.push({ Any: totalToAny })
            this.donutChart1.chartOptions.colors.push(this.arrColor[topTo])
            this.donutChart1.chartOptions.labels.push('Any')
          }
          // console.log('arrTo: ', arrTo)

          this.donutChart1.series = []
          for await (const ct of arrTo) {
            this.donutChart1.series.push(Object.entries(ct)[0][1])
          }
        } else {
          this.donutChart1.series = []
          this.donutChart2.series = []
        }

        // for (let clearData of Object.entries(this.dataBranchDonutDupkey)) {
        //   this.dataBranchDonutDupkey[clearData[0]] = 0
        // }
        const dataBydate = {}
        let newLineData = []
        let sortLineData = []
        let dataH = []
        let labelH = []
        this.dataRowDupp = []
        // console.log('this.WherehouseName >>', this.WherehouseName)
        // console.log('this.dataBranchLinechart >>', this.dataBranchLinechart)
        this.countTotalTable = 0
        for (let addData of Object.entries(this.dataBranchDonutDupkey)) {
          console.log('addData', addData)
          this.dataRowDupp.push({
            text: addData[0] - 1 + ' ครั้ง',
            value: addData[1],
            persens: ''
          })
          this.countTotalTable += addData[1]
        }

        for await (let d of this.WherehouseName) {
          if (this.sumByDate2[d] !== undefined) {
            for await (const vx of Object.entries(this.sumByDate2[d]) || []) {
              this.sumNows += vx[1]
            }
          }
          // console.log('this.sumBefores befor plush : ', this.sumBefores)
          if (this.sumByDate1[d] !== undefined) {
            // console.log(
            //   'this.sumByDate1[d] : ',
            //   d,
            //   ' = ',
            //   this.sumByDate1[d],
            //   this.sumBefores
            // )
            for await (const vx of Object.entries(this.sumByDate1[d]) || []) {
              // console.log('vx[1] :::: ', vx[1])
              this.sumBefores += vx[1]
            }
            // console.log('his.sumBefores xxxx : ', this.sumBefores)
          }

          this.barChartVatical1.chartOptions.colors.push(
            this.dfColor[d] === undefined ? '#472b5a' : this.dfColor[d][0]
          )
          this.barChartHorizon.chartOptions.colors.push(
            this.dfColor[d] === undefined ? '#472b5a' : this.dfColor[d][0]
          )
          for await (let t of Object.entries(this.dataBranchLinechart[[d]])) {
            if (dataBydate[t[1].x] === undefined) {
              dataBydate[t[1].x] = {}
              dataBydate[t[1].x]['y'] = parseInt(t[1].y)
              dataBydate[t[1].x]['x'] = t[1].x
            } else {
              dataBydate[t[1].x]['y'] += parseInt(t[1].y)
            }
            sortLineData.push(t[1].x)
          }
          sortLineData.sort()
          this.barChartVatical1.series[0].data.push(this.dataBranchVatical1[d])
          this.barChartVatical1.chartOptions.xaxis.categories.push(d)
          this.barChartVatical2.chartOptions.xaxis.categories.push(d)
          const objHorizonData = { name: d, data: [] }
          for await (const vH of Object.entries(this.sortItemGroupObj)) {
            if (chkWhereHouseData === 0) {
              labelH.push(vH[0])
            }
            objHorizonData.data.push(this.dataBranchHorizontal[d][vH[0]])
          }
          dataH.push(objHorizonData)
          if (chkWhereHouseData === 0) {
            this.barChartVatical2.series.push({ name: 'เก่า', data: [] })
            this.barChartVatical2.series.push({ name: 'ใหม่', data: [] })
          }
          this.userOld += this.countStatusMember[d][0]
          this.userNews += this.countStatusMember[d][1]
          // console.log('dddd : ', d, this.dfColor[d])
          this.barChartVatical2.series[0].data.push({
            x: d,
            y: this.countStatusMember[d][0] || 0,
            fillColor:
              this.dfColor[d] === undefined ? '#472b5a' : this.dfColor[d][0]
          })
          this.barChartVatical2.series[1].data.push({
            x: d,
            y: this.countStatusMember[d][1] || 0,
            fillColor:
              this.dfColor[d] === undefined ? '#987fa4' : this.dfColor[d][1]
          })
          // console.log('this.dataBranchDonutDupkey >>>', this.dataBranchDonutDupkey)
          // for (const doN of Object.entries(this.dataBranchDonutDup[d])) {
          //   // console.log('doN', doN)
          //   this.dataBranchDonutDupkey[doN[0]] += doN[1]
          // }
          chkWhereHouseData++
        }
        console.log('this.dataRowDupp >>>>>', this.dataRowDupp)
        let xxx = 0
        // console.log('this.sumNows', this.sumNows)
        // console.log('this.sumBefores', this.sumBefores)
        if (this.sumBefores >= this.sumNows) {
          xxx = this.sumBefores - this.sumNows
          this.persenNow = [
            '-' + ((xxx / this.sumBefores) * 100).toFixed(2),
            false
          ]
        } else {
          xxx = this.sumNows - this.sumBefores
          this.persenNow = [
            '+' + ((xxx / this.sumNows) * 100).toFixed(2),
            true
          ]
        }
        // console.log(' this.persenNow ', this.persenNow)
        let chkR = 0
        for await (let r of sortLineData) {
          if (chkR !== r) {
            newLineData.push(dataBydate[r])
          }
          chkR = r
        }
        let chkDataH = []
        let newDataH = []
        if (dataH.length) {
          if (dataH[0]['data'].length) {
            let keyDatah = 0
            // eslint-disable-next-line no-unused-vars
            for await (const dh of dataH[0]['data']) {
              let chkZero = 0
              for await (const t of dataH) {
                if (keyDatah === 0) {
                  newDataH.push({ data: [], name: t.name })
                }
                chkZero += t.data[keyDatah]
              }
              if (chkZero !== 0) {
                chkDataH.push(keyDatah)
              }
              keyDatah++
            }
          }
          for await (const kS of chkDataH) {
            for await (const t of dataH) {
              newDataH.find((e) => e.name === t.name)['data'].push(t.data[kS])
            }
            this.barChartHorizon.chartOptions.xaxis.categories.push(labelH[kS])
          }
          for await (const i of newDataH) {
            this.barChartHorizon.series.push(i)
          }
        }

        // console.log('this.dataBranchDonutDupkey >>', this.dataBranchDonutDupkey)
        this.lineChart.series.push({
          name: 'All',
          data: newLineData
        })
        this.dataHeadDupp = [] //
        this.dataHeadDupp = [
          { text: 'จำนวนการซื้อซ้ำ', value: 'text' },
          { text: 'จำนวนคน', value: 'value' },
          { text: 'คิดเป็น (%)', value: 'persens' }
        ]
        // for (let addData of Object.entries(this.dataBranchDonutDupkey)) {
        //   // console.log('addData', addData)
        //   if (parseInt(addData[0]) !== 1) {
        //     this.dataRowDupp.push({
        //       text: addData[0] - 1 + ' ครั้ง',
        //       value: addData[1],
        //       persens: ''
        //     })
        //     this.countTotalTable += addData[1]
        //   }
        // }

        try {
          if (this.barChartHorizon.series.length) {
            await this.$refs.barChartHorizon.updateOptions(
              this.barChartHorizon.chartOptions
            )
            await this.$refs.barChartHorizon.updateSeries(
              this.barChartHorizon.series
            )
          }
        } catch (errs) {
          console.log('>>>>>>> ERROR', errs)
        }
        if (this.lineChart.series.length) {
          await this.$refs.lineChart.updateOptions(this.lineChart.chartOptions)
          await this.$refs.lineChart.updateSeries(this.lineChart.series)
        }

        if (this.barChartVatical1.series.length) {
          await this.$refs.barChartVatical1.updateOptions(
            this.barChartVatical1.chartOptions
          )
          await this.$refs.barChartVatical1.updateSeries(
            this.barChartVatical1.series
          )
        } else {
          await this.$refs.barChartVatical1.updateOptions(
            this.barChartVatical1.chartOptions
          )
          await this.$refs.barChartVatical1.updateSeries([])
        }

        if (this.barChartVatical2.series.length) {
          await this.$refs.barChartVatical2.updateOptions(
            this.barChartVatical2.chartOptions
          )
          await this.$refs.barChartVatical2.updateSeries(
            this.barChartVatical2.series
          )
        }

        if (this.donutChart1.series.length) {
          await this.$refs.donutChart1.updateOptions(
            this.donutChart1.chartOptions
          )
          await this.$refs.donutChart1.updateSeries(this.donutChart1.series)
        }

        if (this.donutChart2.series.length) {
          await this.$refs.donutChart2.updateOptions(
            this.donutChart2.chartOptions
          )
          await this.$refs.donutChart2.updateSeries(this.donutChart2.series)
        }

        if (this.barChartHorizon2.series.length) {
          await this.$refs.barChartHorizon2.updateOptions(
            this.barChartHorizon2.chartOptions
          )

          await this.$refs.barChartHorizon2.updateSeries(
            this.barChartHorizon2.series
          )
        }
      } catch (errs) {
        console.log('err changeWhere : ', errs)
      }
    },
    async clearDash () {
      this.barChartHorizon2.chartOptions.colors = []
      this.barChartHorizon2.chartOptions.xaxis.categories = []
      this.barChartVatical1.chartOptions.xaxis.categories = []
      this.barChartVatical2.chartOptions.xaxis.categories = []
      this.barChartHorizon.chartOptions.xaxis.categories = []
      this.donutChart2.chartOptions.labels = []
      this.donutChart2.chartOptions.colors = []
      this.donutChart1.chartOptions.labels = []
      this.donutChart1.chartOptions.colors = []
      this.barChartVatical1.chartOptions.colors = []
      this.barChartHorizon.chartOptions.colors = []
      this.userOld = 0
      this.userNews = 0
      this.dataRowDupp = []
      this.sumNows = 0

      this.barChartHorizon.series = []
      this.lineChart.series = []
      this.barChartVatical1.series = [
        {
          name: 'ยอดขาย',
          data: []
        }
      ]
      this.barChartVatical2.series = []
      this.donutChart1.series = []
      this.donutChart2.series = []
      this.barChartHorizon2.series = []
      await this.$refs.barChartHorizon.updateOptions(
        this.barChartHorizon.chartOptions
      )
      await this.$refs.barChartHorizon.updateSeries(
        this.barChartHorizon.series
      )
      await this.$refs.lineChart.updateOptions(this.lineChart.chartOptions)
      await this.$refs.lineChart.updateSeries(this.lineChart.series)

      await this.$refs.barChartVatical1.updateOptions(
        this.barChartVatical1.chartOptions
      )
      await this.$refs.barChartVatical1.updateSeries(
        this.barChartVatical1.series
      )
      await this.$refs.barChartVatical2.updateOptions(
        this.barChartVatical2.chartOptions
      )
      await this.$refs.barChartVatical2.updateSeries(
        this.barChartVatical2.series
      )
      await this.$refs.donutChart1.updateOptions(this.donutChart1.chartOptions)
      await this.$refs.donutChart1.updateSeries(this.donutChart1.series)
      await this.$refs.donutChart2.updateOptions(this.donutChart2.chartOptions)
      await this.$refs.donutChart2.updateSeries(this.donutChart2.series)
      await this.$refs.barChartHorizon2.updateOptions(
        this.barChartHorizon2.chartOptions
      )
      await this.$refs.barChartHorizon2.updateSeries(
        this.barChartHorizon2.series
      )
    },
    async chackDate () {
      try {
        this.dataWherehouse = []
        if (this.date.length === 0) {
          this.date = this.getDate30()
        } else if (this.date.length === 1) {
          this.date.push(this.date[0])
        } else if (this.date.length === 2) {
          this.date.sort()
        }
        const whereHouse = await axios.post(
          this.DNS_IP + '/hitorysell/get-wherehouse',
          { DOCDATE: this.date }
        )
        this.WherehouseName = []
        if (whereHouse.data.length) {
          let ix = 1
          this.dataBranchVatical1 = {}
          for await (const i of whereHouse.data) {
            // this.dataBranchLinechart[i.BRANCHCODE] = []
            // this.dataBranchKeyDateLinechart[i.BRANCHCODE] = {}
            // for (
            //   let day = new Date(this.date[0]);
            //   day <= new Date(this.date[1]);
            //   day.setDate(day.getDate() + 1)
            // ) {
            //   const keyDate = moment(day).format('YYYY-MM-DD')
            //   this.dataBranchKeyDateLinechart[i.BRANCHCODE][keyDate] = 0
            // }
            this.dataWherehouse.push({
              text: i.BRANCHCODE,
              value: i.BRANCHCODE
            })
            // this.dataBranchDonut[i.BRANCHCODE] = [0, 0]
            // this.dataBranchVatical1[i.BRANCHCODE] = 0
            // this.dataBranchVatical2[i.BRANCHCODE] = []
            // this.dataBranchStack[i.BRANCHCODE] = {}
            // this.dataBranchHorizontal[i.BRANCHCODE] = null
            // this.dataBranchDonutDup[i.BRANCHCODE] = {}
            if (ix <= 5) {
              this.WherehouseName.push(i.BRANCHCODE)
            }
            ix++
          }
          this.sent2()
        } else {
          await this.clearDash()
        }
      } catch (errs) {
        console.log('errs : ', errs)
      }
    }
  }
}
</script>
<style scoped>
.container-overview {
  background-color: white;
  min-height: 132px;
  border-radius: 17px;
  padding: 20px;
  align-items: center;
}
.container-overview-slim {
  background-color: white;
  /* min-height: 132px; */
  border-radius: 17px;
  /* padding: 20px; */
  align-items: center;
}
.v-input--selection-controls__input > .v-icon {
  color: #d9d9d9 !important;
}
.bgPage {
  background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
}
hr {
  border: none;
  border-top: 4px dotted grey;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 50%;
  margin-top: 30px;
}
.main {
  padding: 0px;
  background: #ffffff;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/Core/DashboardBVP.vue